import { adminApi } from "../http/httpClient";

export interface SendCallStartInput {
  name: string;
  email: string;
  phone: string;
  company: string;
  message: string;
  subject: string;
}

export const sendCallStart = async (payload: SendCallStartInput) => {
  const { data } = await adminApi.post("/contact", payload);

  return data;
};
